module.exports = __webpack_public_path__ + "img/offers.b525b458.png";